import styled from 'styled-components';

export const StyledListItem = styled.span`
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const StyledDiv = styled.div`
  display: flex;
  width: 100%;
  padding: 5px 0 5px 0;
  align-items: center;
  :hover {
    background: #dcdcdc;
  }
`;
export const StyledButtonP = styled.p`
  margin-right: 15px;
  cursor: pointer;
  min-width: 70px;
  min-height: 25px;
  text-align: center;
  color: #c44949;
  :hover {
    background: #9c9a9a;
    border-radius: 5px;
  }
`;
